import { Box, CircularProgress, CircularProgressLabel, Spinner, Text } from '@chakra-ui/react';
import i18next from 'i18next';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import type { Sim } from 'utils/graphql/hooks';
import { dataVolumeUsedText } from 'utils/simUtils';

interface DataVolumeUsageDiagramProps {
  labelId: string;
  dataVolumeCount: number;
  dataVolumeLimit: number | Pick<Sim, 'data'>['data']['limit'];
  canExceedDataVolume?: boolean;
  isLoading?: boolean;
}

export const DataVolumeUsageDiagram: FunctionComponent<DataVolumeUsageDiagramProps> = ({
  labelId,
  dataVolumeCount,
  dataVolumeLimit,
  canExceedDataVolume = false,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <CircularProgress
      value={dataVolumeLimit ? (dataVolumeCount / dataVolumeLimit) * 100 : 0}
      size="48"
      thickness="4"
      color={
        !canExceedDataVolume && dataVolumeLimit && dataVolumeCount >= dataVolumeLimit
          ? 'mRed.500'
          : 'mGreen.500'
      }
      trackColor="gray.50"
      capIsRound
      role="presentation"
      // on role presentation these initially set aria labels make no sense
      aria-valuemax={undefined}
      aria-valuemin={undefined}
      aria-valuenow={undefined}
    >
      <CircularProgressLabel>
        {isLoading ? (
          <Spinner />
        ) : (
          <Text aria-describedby={labelId}>
            <>
              <Box
                as="strong"
                fontSize="2xl"
                title={t('sim.dataVolume.exact', {
                  used: Intl.NumberFormat(i18next.language).format(dataVolumeCount),
                })}
              >
                {dataVolumeUsedText({ count: dataVolumeCount, limit: dataVolumeLimit })}
              </Box>
              <br />
            </>
            {t('sim.dataVolume.used')}
          </Text>
        )}
      </CircularProgressLabel>
    </CircularProgress>
  );
};
